var _circle, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioBlueBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 308,
    viewBox: "0 0 336 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 48.5,
    cy: 20.5,
    r: 287.5,
    fill: "#B5CAFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 90,
    cy: -33.5,
    rx: 163,
    ry: 163.5,
    fill: "#8DA3CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioBlueBanner);
export default __webpack_public_path__ + "static/media/portfolio-blue-banner.afba71e45701bce19c4b371c091b7944.svg";
export { ForwardRef as ReactComponent };